import script from "./Ellipse.vue?vue&type=script&setup=true&lang=js"
export * from "./Ellipse.vue?vue&type=script&setup=true&lang=js"

import "./Ellipse.vue?vue&type=style&index=0&id=72727d08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72727d08"]])

export default __exports__